import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-5 col-xl-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  id: "myTab",
  role: "tablist"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", {
  class: "nav-item",
  role: "presentation"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100 active",
    id: "course-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#course-tab-pane",
    type: "button",
    role: "tab",
    "aria-controls": "shipping-details-tab-pane",
    "aria-selected": "true"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-form" }),
    /*#__PURE__*/_createTextVNode(" DATOS GENERALES ")
  ])
], -1)
const _hoisted_7 = {
  key: 0,
  class: "nav-item",
  role: "presentation"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
  id: "groups-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#groups-tab-pane",
  type: "button",
  role: "tab",
  "aria-controls": "groups-tab-pane",
  "aria-selected": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-users-group" }),
  /*#__PURE__*/_createTextVNode(" GRUPOS ASOCIADOS ")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "nav-item",
  role: "presentation"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
  id: "occupation-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#occupation-tab-pane",
  type: "button",
  role: "tab",
  "aria-controls": "occupation-tab-pane",
  "aria-selected": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-layer-2" }),
  /*#__PURE__*/_createTextVNode(" OCUPACIÓN MAXIMA GRUPOS ")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_14 = {
  class: "tab-pane fade show active",
  id: "course-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_15 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_16 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nombre", -1)
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Sede", -1)
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Jornada", -1)
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nivel", -1)
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Descripción", -1)
const _hoisted_33 = { class: "mb-0" }
const _hoisted_34 = { class: "col-md-12" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Estado", -1)
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, "Cancelar", -1)
const _hoisted_40 = {
  key: 0,
  class: "tab-pane fade",
  id: "groups-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_41 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_42 = {
  key: 1,
  class: "tab-pane fade",
  id: "occupation-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_43 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_GroupsContent = _resolveComponent("GroupsContent")!
  const _component_CourseGroupsCapacity = _resolveComponent("CourseGroupsCapacity")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BreadCrumb, { PageTitle: "Cursos" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _hoisted_6,
          (_ctx.form.record.Id > 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.form.record.Id > 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_b_form, {
                  ref: "formRecord",
                  id: "formModal",
                  onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_container, { fluid: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _createVNode(_component_b_form_input, {
                                modelValue: _ctx.form.record.Name,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.Name) = $event)),
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "Nombre del grado",
                                required: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _hoisted_23,
                              _createVNode(_component_SearchSelect, {
                                modelValue: _ctx.form.record.HeadquarterId,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.HeadquarterId) = $event)),
                                required: "",
                                "was-validated": _ctx.form.wasValidated,
                                options: _ctx.headquarters.map(r => ({ value: r.Id, text: `${r.Description}` })),
                                placeholder: "Seleccione la sede"
                              }, null, 8, ["modelValue", "was-validated", "options"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _hoisted_26,
                              _createVNode(_component_b_form_select, {
                                id: "input-doc-type",
                                class: "form-control fs-14 text-black shadow-none form-control-sm",
                                modelValue: _ctx.form.record.JourneyId,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record.JourneyId) = $event)),
                                options: _ctx.journeys,
                                "value-field": "Id",
                                "text-field": "Description",
                                required: ""
                              }, null, 8, ["modelValue", "options"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _hoisted_29,
                              _createVNode(_component_b_form_select, {
                                id: "input-doc-type",
                                class: "form-control fs-14 text-black shadow-none form-control-sm",
                                modelValue: _ctx.form.record.LevelId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.LevelId) = $event)),
                                options: _ctx.categories,
                                "value-field": "Id",
                                "text-field": "Description",
                                required: ""
                              }, null, 8, ["modelValue", "options"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _hoisted_32,
                              _createElementVNode("div", _hoisted_33, [
                                _createVNode(_component_QuillEditor, {
                                  content: _ctx.form.record.Description,
                                  "onUpdate:content": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.Description) = $event)),
                                  "content-type": "text",
                                  theme: "snow",
                                  toolbar: "full",
                                  placeholder: "Escriba una descripción..."
                                }, null, 8, ["content"])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _createElementVNode("div", null, [
                              _createVNode(_component_b_form_group, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_b_form_checkbox, {
                                    modelValue: _ctx.form.record.Enable,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.record.Enable) = $event)),
                                    value: true
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Activo ")
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_b_button, {
                                class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                                type: "submit"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.form.record.Id ? 'Guardar cambios' : 'Agregar curso'), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_b_button, {
                                onClick: _ctx.cancel,
                                class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_38,
                                  _hoisted_39
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ])
            ])
          ]),
          (_ctx.form.record.Id > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_GroupsContent, {
                    record: _ctx.form.record
                  }, null, 8, ["record"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.record.Id > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_CourseGroupsCapacity, {
                    record: _ctx.form.record
                  }, null, 8, ["record"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}